/**
 * The source's `authFetch`, over the platform's session — App Rationalization's shim
 * (`pages/apr/compat/api.ts`) with the prefix changed.
 *
 * Program Planning's screens are apr_template's Planning & Integration screens and call
 * `authFetch('/api/integration-groups', …)`. The platform mounts their API under
 * `/api/program_planning`, so this rewrites `/api/<x>` to `/api/program_planning/<x>` and
 * sends the session cookie instead of the source's bearer token. Screens are not touched.
 */

/** `/api/integration-groups` -> `/api/program_planning/integration-groups`. */
function toPlatformUrl(url: string): string {
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/program_planning/')) return url;
  if (url.startsWith('/api/')) return `/api/program_planning/${url.slice('/api/'.length)}`;
  return url;
}

export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  // A FormData body must not carry an explicit Content-Type — only the browser knows the
  // multipart boundary (see the same note in pages/apr/compat/api.ts).
  const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;
  const headers: HeadersInit = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(options.headers || {}),
  };
  return fetch(toPlatformUrl(url), {
    ...options,
    headers,
    // The platform's session cookie replaces the source's bearer token.
    credentials: 'include',
  });
};
